import { useState } from 'react';
import { Card, Checkbox, Button, Popover } from '@material-ui/core';
import { themeButtons } from '../../../css/themeButtons';

const PhotoCardItem = ({ src, checkBoxHandler, checked, reason }) => {
  const buttons = themeButtons();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleShowReasonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleReasonClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className={'col card-sortable'}>
      <Card className='card card-photo h-100'>
        <Checkbox
          checked={checked}
          className='card-check handle-sortable-filtered'
          onChange={checkBoxHandler}
        />
        {!reason ? null : (
          <div className='function-btns'>
            <Button
              onClick={handleShowReasonClick}
              className={`btn ${buttons.btnLight} mt-1`}
            >
              Узнать причину
            </Button>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleReasonClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
            >
              <p style={{ padding: '1rem', maxWidth: '12rem' }}>{reason}</p>
            </Popover>
          </div>
        )}
        <img src={src} className='card-img w-100 h-100' alt='' />
      </Card>
    </div>
  );
};

export default PhotoCardItem;
